<template>
  <div>
    <v-card outlined>
      <v-card-title>Привязанные материалы</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="materialItems"
          item-key="_id"
        >
          <template v-slot:top>
            <v-autocomplete
              v-model="link"
              :items="materialLinks"
              label="Добавление материала"
              placeholder="Введите название товара или категории"
              dense
              filled
              item-text="linkName"
              item-value="_id"
            ></v-autocomplete>
          </template>

          <template v-slot:[`item.expensePerUnit`]="{ item }">
            <number-field
              :value="item.expensePerUnit"
              @changed="changeExpense(item._id, $event)"
            ></number-field>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="deleteMaterialLink(item._id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
       
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'connected-materials',

  props: {
    materials: {
      type: Array,
      required: true
    },
    
  },

  data() {
    return {
      link: null,
      tableHeaders: [
        {
          text: 'Тип',
          value: 'linkType'
        },
        {
          text: 'Наименование',
          value: 'name'
        },
        {
          text: 'Ед. изм.',
          value: 'unitName'
        },
        {
          text: 'Расход (на 1 ед. работы)',
          value: 'expensePerUnit'
        },
        {
          text: 'Действия',
          value: 'actions'
        }
      ]
    }
  },

  methods: {
    createMaterialLink(val) {
      let ind = this.materials.findIndex(x => x._id == val._id);
      if (ind != -1) {
        this.$store.dispatch('showMessage', 'Материал уже добавлен к работе.');
      } else {
        this.materials.push({
          _id: val._id,
          isCategory: val.isCategory,
          expensePerUnit: val.expensePerUnit
        });
      }
    },
    deleteMaterialLink(id) {
      let ind = this.materials.findIndex(x => x._id == id);
      this.materials.splice(ind, 1);
    },
    changeExpense(id, val) {
      if (this.isNumber(val) || Number(val) > 0) {
        let material = this.materials.find(x => x._id == id); 
        material.expensePerUnit = val;
      }
    }
  },

  watch: {
    link(val) {
      if (val) {
        this.createMaterialLink(this.materialLinks.find(x => x._id == val));
        this.$nextTick(() => {
          this.link = null;
        });
      }
    }
  },

  computed: {
    ...mapGetters('prices', ['materialLinks']),
    materialItems() {
      return this.materials.map(item => ({
        ...item,
        linkType: item.isCategory ? 'Категория' : 'Товар',
        name: item.isCategory ? 
          this.$store.getters['prices/getMaterialCategoryById'](item._id).name : 
          this.$store.getters['prices/getMaterialById'](item._id).name,
        unitName: item.isCategory ? 
          this.$store.getters['prices/getMaterialCategoryById'](item._id).unitName : 
          this.$store.getters['prices/getMaterialById'](item._id).unitName,
      }));
    }
  }
}
</script>